import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

const client = sanityClient({
  projectId: 'dh0yop6z', // ← bytt til ditt prosjekt-ID
  dataset: 'production',
  apiVersion: '2023-01-01', // sett API-versjon
  useCdn: true,
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);

export { client };